import React, { Component } from "react";
import Ink from "react-ink";
import LightSpeed from "react-reveal/LightSpeed";
//import { WEBSITE_URL } from "../../../configs/website";
import WebShare from "../WebShare";
import HomeIcon from '@mui/icons-material/Home';

class BackWithSearch extends Component {
  static contextTypes = {
    router: () => null,
  };

  render() {
    const title = this.props.isSingleItemDescription
      ? this.props.single_item.brand
        ? this.props.single_item.brand + " - " + this.props.single_item.name
        : this.props.single_item.name
      : this.props.restaurant.name;
    const id = this.props.isSingleItemDescription
      ? this.props.single_item.id
      : "";

    let url = this.props.restaurant.slug;
    if (id) {
      url = url + "/" + id;
    }

    return (
      <React.Fragment>
        <div className="col-12 p-0 fixed" style={{ zIndex: "9" }}>
          <div className="block m-0">
            <div
              className={`block-content p-0 ${this.props.dark && "nav-dark"}`}
            >
              <div
                className={`input-group ${this.props.boxshadow &&
                  "search-box"}`}
              >
                {!this.props.disable_back_button && (
                  <div className="input-group-prepend">
                    {this.props.back_to_home && (
                      <button
                        type="button"
                        className="btn search-navs-btns"
                        style={{ position: "relative", border: "none" }}
                        onClick={() => {
                          setTimeout(() => {
                            this.context.router.history.push("/");
                          }, 200);
                        }}
                      >
                        <i className="si si-arrow-left" />
                        <Ink duration="500" />
                      </button>
                    )}

                    {this.props.goto_orders_page && (
                      <button
                        type="button"
                        className="btn search-navs-btns"
                        style={{ position: "relative", border: "none" }}
                        onClick={() => {
                          setTimeout(() => {
                            this.context.router.history.push("/my-orders");
                          }, 200);
                        }}
                      >
                        <i className="si si-arrow-left" />
                        <Ink duration="500" />
                      </button>
                    )}
                    {this.props.goto_accounts_page && (
                      <button
                        type="button"
                        className="btn search-navs-btns"
                        style={{ position: "relative", border: "none" }}
                        onClick={() => {
                          setTimeout(() => {
                            this.context.router.history.push("/my-account");
                          }, 200);
                        }}
                      >
                        <i className="si si-arrow-left" />
                        <Ink duration="500" />
                      </button>
                    )}
                    {!this.props.back_to_home &&
                      !this.props.goto_orders_page &&
                      !this.props.goto_accounts_page && (
                        <button
                          type="button"
                          className={`btn search-navs-btns ${this.props.dark &&
                            "nav-dark"}`}
                          style={{ position: "relative", border: "none" }}
                          onClick={() => {
                            setTimeout(() => {
                              this.context.router.history.goBack();
                            }, 200);
                          }}
                        >
                          <i className="si si-arrow-left" />
                          <Ink duration="500" />
                        </button>
                      )}
                  </div>
                )}
                <p
                  className={`form-control search-input d-flex align-items-center ${this
                    .props.dark && "nav-dark"}`}
                  style={{ border: "none" }}
                >
                  {this.props.logo && (
                    <img
                      src="/assets/img/logos/logo.png"
                      alt={localStorage.getItem("storeName")}
                      width="120"
                    />
                  )}
                  {this.props.has_title ? (
                    <React.Fragment>
                      {this.props.from_checkout ? (
                        <span className="nav-page-title">
                          {localStorage.getItem("cartToPayText")}{" "}
                          <span
                            style={{
                              color: localStorage.getItem("storeColor"),
                            }}
                          >
                            {localStorage.getItem("currencySymbolAlign") ===
                              "left" && localStorage.getItem("currencyFormat")}
                            {this.props.title}
                            {localStorage.getItem("currencySymbolAlign") ===
                              "right" && localStorage.getItem("currencyFormat")}
                          </span>
                        </span>
                      ) : (
                        <span className="nav-page-title">
                          {this.props.title}
                        </span>
                      )}
                    </React.Fragment>
                  ) : null}
                  {this.props.has_delivery_icon && (
                    <LightSpeed left>
                      <img
                        src="/assets/img/various/delivery-bike.png"
                        alt={this.props.title}
                        className="nav-page-title"
                      />
                    </LightSpeed>
                  )}
                </p>
                <div
                  className={`fixed-restaurant-info ${
                    !this.props.isSingleItemDescription ? "hidden" : ""
                  }`}
                  ref={(node) => {
                    this.heading = node;
                  }}
                >
                  <span className="font-w700 fixedRestaurantName">
                    {this.props.isSingleItemDescription
                      ? this.props.single_item.name
                      : this.props.restaurant.name
                      ? this.props.restaurant.name
                      : null}
                  </span>
                </div>
                <div className="input-group-append">
                  {!this.props.disable_search && (
                    <button
                      type="submit"
                      className="btn search-navs-btns"
                      style={{
                        position: "relative",
                        maxWidth: "40px",
                        padding: "4px",
                      }}
                    >
                      <i className="si si-magnifier" />
                      <Ink duration="500" />
                    </button>
                  )}
                  {this.props.homeButton && (
                    <button
                      type="button"
                      className="btn search-navs-btns nav-home-btn"
                      style={{
                        position: "relative",
                        maxWidth: "40px",
                        padding: "4px",
                        marginTop: "3px",
                        height: "52px",
                      }}
                      onClick={() => {
                        setTimeout(() => {
                          this.context.router.history.push("/");
                        }, 200);
                      }}
                    >
                      {/* <i className="si si-home" /> */}
                      <HomeIcon fontSize="large" style={{width: "25.44px", height: "25.44px"}} />

                    

                      
                      <Ink duration="500" />
                    </button>
                  )}
                  {/* {this.props.homeButton && ( */}
                  <button
                    type="button"
                    className="btn search-navs-btns nav-home-btn"
                    style={{
                      position: "relative",
                      fontSize: "1.5rem",
                      maxWidth: "40px",
                      padding: "9px",
                    }}
                    onClick={() => {
                      setTimeout(() => {
                        this.context.router.history.push("/my-favorite-stores");
                      }, 200);
                    }}
                  >
                    {/* <i className="si si-heart" /> */}
                    <svg  style={{width: "20px"}} aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" class="svg-inline--fa fa-heart " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"></path></svg>
                    <Ink duration="500" />
                  </button>
                  {/* )} */}
                  {this.props.shareButton && (
                    <WebShare link={url} title={title} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default BackWithSearch;
